'use strict';

var _ = require('lodash');
var OnlineLogitCalibrationTransformerFactory = function OnlineLogitCalibrationTransformerFactory(DataTransformer) {
  function OnlineLogitCalibrationTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'online-logit-calibration-mode';
    this.targetType = 'online-logit-calibration-review';
    this.priority = 1;
  }
  OnlineLogitCalibrationTransformer.prototype = Object.create(DataTransformer.prototype);
  OnlineLogitCalibrationTransformer.constructor = OnlineLogitCalibrationTransformer;
  OnlineLogitCalibrationTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  OnlineLogitCalibrationTransformer.prototype.isCacheable = function () {
    return false;
  };
  OnlineLogitCalibrationTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  OnlineLogitCalibrationTransformer.prototype.transform = function (data) {
    return [];
  };
  return OnlineLogitCalibrationTransformer;
};
OnlineLogitCalibrationTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = OnlineLogitCalibrationTransformerFactory;